export default {"src":"/_next/static/image/public/images/ic_delete_hc.6ff0d64c53e260f4b004908bcd5300b1.svg","height":14,"width":12};